<template>
  <v-select
    v-model="filter.municipiosSolucoesTipoSolucaoId"
    :items="tipos"
    item-text="tipo"
    item-value="id"
    label="Tipo de Solução"
    placeholder="Selecione..."
    clearable
    v-on:change="$emit('onChange')"
  >
    <template slot="no-data">Nenhum tipo encontrado</template>
  </v-select>
</template>

<script>
import { municipiosSolucoesTipoSolucaoAPI } from "../API/MunicipiosSolucoesTipoSolucaoAPI";

export default {
  name: "ComboboxMunicipiosSolucoesTipoSolucao",
  props: {
    filter: { type: Object, required: true },
  },
  data() {
    return { tipos: [] };
  },
  async mounted() {
    const { data } = await municipiosSolucoesTipoSolucaoAPI.list();
    this.tipos = data;
  },
};
</script>
